
  <button
          c *ngIf="(flagService.getFlags$() | async)?.[FeatureFlags.DUAL_VIEW]"
    id="dualview-toolbar-button"
    class="mat-icon-toggle-button"
    type="button"
    matIconButton
    matTooltip="Dual View"
    [class.selected]="dualCommunicatorService.dualEnabled$ | async"
    (click)="changeDualViewStatus()"
    matTooltipPosition="right">
    <mat-icon svgIcon="dual_view"></mat-icon>
  </button>

